import React from 'react';
import {
  EntityListResponse,
  ProductListResponse,
  ScopeOverviewResponse,
  ScopeResponse,
} from '@ydistri/api-sdk';
import { formatDate, formatDateTime } from '@ydistri/generic-utils';
import { Column, ReadOnlyItem } from '@ydistri/ds';

interface AdministrationItemCardPopoverContentProps {
  item: ProductListResponse | EntityListResponse | ScopeOverviewResponse | ScopeResponse;
}

interface PopOverContent {
  label: string;
  value: string;
}

/**
 * Display various dates related to the item (created, updated, archived)
 * @param item
 * @constructor
 */
const AdministrationItemCardPopoverContent: React.FC<AdministrationItemCardPopoverContentProps> = ({
  item,
}) => {
  // if 'Scheduled archive on' is later included, then the label must be longer
  let useShortLabel = true;

  const content: PopOverContent[] = [
    {
      label: 'Created at',
      value: formatDateTime(item.createdAt),
    },
    {
      label: 'Updated at',
      value: formatDateTime('lastUpdatedAt' in item ? item.lastUpdatedAt : item.updatedAt),
    },
  ];

  //for some items (Product list, Request list) the archivedAt is not available
  if (item.isArchived) {
    if ('archivedAt' in item && item.archivedAt) {
      content.push({
        label: 'Archived at',
        value: formatDateTime(item.archivedAt),
      });
    }
  } else if ('scheduledArchiveOn' in item) {
    //scheduledArchiveOn may be null or not available
    content.push({
      label: 'Scheduled archive on',
      value: item.scheduledArchiveOn ? formatDate(item.scheduledArchiveOn) : 'never',
    });
    useShortLabel = false;
  }

  return (
    <Column>
      {content.map(item => (
        <ReadOnlyItem
          key={item.label}
          labelWidth={useShortLabel ? '6rem' : '10rem'}
          label={item.label}
          value={item.value}
        />
      ))}
    </Column>
  );
};

export default AdministrationItemCardPopoverContent;
